import sala05Gallery1 from "../../assets/senca/projects/sala-05/gallery-1.jpg";
import sala05Gallery2 from "../../assets/senca/projects/sala-05/gallery-2.jpg";
import sala05Gallery3 from "../../assets/senca/projects/sala-05/gallery-3.jpg";
import sala01Gallery1 from "../../assets/senca/projects/sala-01/gallery-1.jpg";
import sala01Gallery2 from "../../assets/senca/projects/sala-01/gallery-2.jpg";
import salaMultiusoGallery1 from "../../assets/senca/projects/sala-multiuso/gallery-1.jpg";
import salaMultiusoGallery2 from "../../assets/senca/projects/sala-multiuso/gallery-2.jpg";
import baseSegurancaGallery1 from "../../assets/senca/projects/base-seguranca-usp/gallery-1.jpg";
import baseSegurancaGallery2 from "../../assets/senca/projects/base-seguranca-usp/gallery-2.jpg";

export const projectsBySlug = {
  "conjunto-comercial-plinio-correa": {
    slug: "conjunto-comercial-plinio-correa",
    title:
      "1º Reforma da Sala 05 da Medicina Nuclear - Ambulatório - Bl.3 - INCOR – HCFMUSP",
    startDate: "10/10/2022",
    endDate: "08/12/2022",
    location: "Incor - HCFMUSP",
    description:
      "Reforma completa, contando com instalação de piso vinílico, Instalação de forro modular removível e instalação de maquina",
    gallery: [sala05Gallery1, sala05Gallery2, sala05Gallery3],
  },
  "galpao-industrial-sao-cristovao": {
    slug: "galpao-industrial-sao-cristovao",
    title:
      "Reforma da sala 1 – Hemodinâmica – 3º Andar – Bloco 1 – INCOR",
    startDate: "04/04/2024",
    endDate: "29/06/2024",
    location: "HCFMUSP - Incor hemodinâmica sala 1",
    description:
      "Execução de reforma geral da sala, troca de piso vinílico, instalação de estrutura para máquina de Hemodinâmica da Philips.",
    gallery: [sala01Gallery1, sala01Gallery2],
  },
  "condominio-vila-nova": {
    slug: "condominio-vila-nova",
    title:
      "FACULDADE DE MEDICINA DA USP – REFORMA SALA 1357 – IMPLANTAÇÃO SALA MULTIUSO",
    startDate: "05/04/2022",
    endDate: "04/05/2022",
    location:
      "Faculdade de medicina da USP – Reforma sala multiuso Sala 1357",
    description:
      "Reforma da sala 1357 e implantação de sala multiuso na Faculdade de Medicina da USP.",
    gallery: [salaMultiusoGallery1, salaMultiusoGallery2],
  },
  "infraestrutura-do-loteamento-jatoba": {
    slug: "infraestrutura-do-loteamento-jatoba",
    title: "Base de Segurança Campus - USP",
    startDate: "02/12/2019",
    endDate: "12/09/2020",
    location: "Superintendência de Segurança da USP – USP Butantã",
    description:
      'Execução dos serviços de reforma para a Base de Segurança Comunitária da CUASO – Campus Universitário "Armando de Salles Oliveira", da Superintendência de Segurança da USP',
    gallery: [baseSegurancaGallery1, baseSegurancaGallery2],
  },
};

export function getProjectBySlug(slug) {
  return projectsBySlug[slug] ?? null;
}
